import { msg } from "@omegagrid/localize";
import { ColumnSource, RowSource } from "@omegagrid/grid";
import rp, { GridEditorAdapter, GridEditorOptions, RowData } from "@reporting/rp-app-host";
import { AccountingOptions } from "@reporting/rp-types/core";
import { AccountingTreeAdapter } from "../adapters";

export class LimitGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;
		this._columns = [{
			t: 'a',
			content: [{
				action: 'delete',
				title: msg('Delete'),
				icon: 'trash',
				color: 'red'
			}, {
				action: 'duplicate',
				title: msg('Duplicate'),
				icon: 'copy',
				color: 'yellow'
			}],
			e: false,
			w: 5 + 20 * 2,
			filter: false
		}, {
			data: 'accounting',
			header: msg('Company'),
			t: 's',
			w: 250,
			e: true,
			adapter: new AccountingTreeAdapter()
		}, {
			data: 'export_limit_timeout',
			header: msg('Timeout (sec)'),
			t: 'n',
			w: 150,
			e: true,
		}, {
			data: 'export_limit_rows_daily',
			header: msg('Row limit'),
			t: 'n',
			w: 150,
			e: true,
		}, {
			data: 'export_limit_size_daily',
			header: msg('Size limit (Bytes)'),
			t: 'n',
			w: 155,
			e: true,
		}, {
			data: 'export_limit_time_daily',
			header: msg('Time limit (Sec)'),
			t: 'n',
			w: 150,
			e: true,
		}];
		return this._columns;
	}

	async getRows(): Promise<RowSource[]> {
		const limits = await rp.ms('accounting').get<AccountingOptions[]>('/limits');
		return limits.map(data => ({ data: {
			...data,
			accounting: { v: data.accounting, dv: `${data.accounting} ${data.company}`, t: 'n', e: false },
		}}));
	}

	async save(rowData: RowData[]) {
		const data = rowData.map(row => Object.assign(
			{ _state: row.state, _index: row.index }, row.data
		));
		await rp.ms('accounting').post('limits', data);
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			rowNumbers: true,
			columnSorting: true,
			filters: true,
			pageSize: null,
			refreshAfterSave: true,
			saveMode: 'edited_rows',
			toolbar: {
				new: {text: msg('Add company')},
			},
			rowMenu: {
				addRows: true,
				deleteRows: true,
			},
		});
	}

}
